(function($) { 

  let $shortcodeSCT = $('.ShortCode.SearchCategoriesText')
  if($shortcodeSCT.length) { 

    $shortcodeSCT = $shortcodeSCT.eq(0)

    const $selectors = $shortcodeSCT.find('.Selectors')
    const $selectorproducts = $selectors.find('.Selector.Products')
    const $selectorindustries = $selectors.find('.Selector.Industries')
    const $textfield = $shortcodeSCT.find('.SearchText input')
    const $searchbutton =  $shortcodeSCT.find('.ButtonSearch')
    const $toggle = $shortcodeSCT.find('.Toggle')
    const lang = $searchbutton.data('lang')

    $textfield
    .on(
      'keypress',
      function(e) {

        if (e.which == 13) {                 
                  
          const searchquery = `/courses-${ lang }?products=${ $selectorproducts.val() }&industries=${ $selectorindustries.val() }&searchtext=${ $textfield.val() }`
          location = location.origin + searchquery
        }
      }
    )
        
    $searchbutton
    .on(
      'click',
      function() {
        
        /*
        console.log($selectorproducts.val())
        console.log($selectorindustries.val())
        console.log($(this).val())
        */

        const searchquery = `/courses-${ lang }?products=${ $selectorproducts.val() }&industries=${ $selectorindustries.val() }&searchtext=${ $textfield.val() }`
        location = location.origin + searchquery

      }
    ) 

    $toggle
    .on(
      'click',
      function() {

        const $this = $(this)

        if($selectors.is(':visible')) {

          $this.addClass('Closed')
          
          $selectors.hide()

        } else {

          $this.removeClass('Closed')
          
          $selectors.show()
        }
      }
    )
  }     

})(jQuery)